import { render, staticRenderFns } from "./ComInfo2.vue?vue&type=template&id=316e096e&scoped=true&"
import script from "./ComInfo2.vue?vue&type=script&lang=js&"
export * from "./ComInfo2.vue?vue&type=script&lang=js&"
import style0 from "./ComInfo2.vue?vue&type=style&index=0&id=316e096e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316e096e",
  null
  
)

export default component.exports